import type { UndefinedOnPartialDeep } from 'type-fest';

import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import type { Service } from '@repo/types/service';

import { ArticleServiceDetails } from '@/components/services-table/article-list-modal/article-service-details/article-service-details.component';

interface Props {
    visible: boolean;
    toggleVisible: () => void;
    service: UndefinedOnPartialDeep<Service> | undefined;
    onClose: () => void;
}

export const ArticleListModal = ({ visible, toggleVisible, service, onClose }: Props) => {
    if (!service) {
        return;
    }

    return (
        <Modal
            handleCloseBtn={toggleVisible}
            visible={visible}
            onModalClosed={() => {
                onClose();
            }}
            data-testid="article-list-modal"
            focusLockProps={{ autoFocusReturn: false }}
        >
            <Sheets
                aria-label={service.serviceName ?? ''}
                header={<ModalHeader title={service.serviceName ?? ''} />}
                footer={null}
            >
                <ModalBody>
                    <ArticleServiceDetails service={service} toggleVisible={toggleVisible} />
                </ModalBody>
            </Sheets>
        </Modal>
    );
};
